import styled from "styled-components";
import { useEffect, useState } from "react";
import { PlainButtonBar, PrimaryButton, SecondaryButton } from "../components/Button";
import { Label, Spacer } from "../editor/EditorHelpers";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TextEditor } from "../components/TextEditor";
import { KEY_OWN_CID, KEY_TOKEN } from "./challengeModel";
import { ChallengeLearnMore, SmallText, StatusText } from "./ChallengeHelpers";
import { useTranslation } from "react-i18next";


function setThemeColor(color) {
  let themeColor = document.querySelector('meta[name="theme-color"]');
  if (!themeColor) {
    themeColor = document.createElement('meta');
    themeColor["name"] = 'theme-color';
    document.head.appendChild(themeColor);
  }
  themeColor.setAttribute('content', color);
}

export default function JoinChallenge() {
  const { t } = useTranslation();
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isLearnMoreOpen, setLearnMoreOpen] = useState(false);
  const { cid } = useParams();
  const navigate = useNavigate();
    
  useEffect(() => {
    console.log("join challenge cid:", cid);
  }, [cid]);

  useEffect(() => {
    const rootElement = document.getElementById('root');    
    rootElement.classList.add("challenge-green");
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (isDark) {
      setThemeColor('hsl(120, 40%, 18%)');
    } else {
      setThemeColor('hsl(120, 40%, 18%)');
    }
    return () => {
      rootElement.classList.remove("challenge-green");
      if (isDark) {
        setThemeColor('#002266');
      } else {
        setThemeColor('#003399');
      }
      }
  }, []);

  const handleJoinSubmit = (e) => {
    e.preventDefault()
    console.log("")
    if (name.length === 0) {
      setError(t('challenge.name-is-required.error'))
    } else {
      recoverOrCreateChallenge();
    }
    // TODO point out required name if needed
    // TODO join
  }

  const handleBack = () => {
    // Current path: /challenge/join/y7gaH9
    const parts = location.pathname.split('/'); // ["", "challenge", "join", "y7gaH9"]

    if (parts.length >= 4 && parts[2] === 'join') {
      const newPath = `/challenge/${parts[3]}`; 
      navigate(newPath);
    } else {
      // fallback if structure isn't as expected
      navigate('/challenge');
    }
  };

  const setNameAndMaybeClearError = (v: string) => {
    if (v.length > 0) {
      setError("");
    }
    setName(v);
  }

  const recoverOrCreateChallenge = () => {
    const formData: Record<string, string> = {
      name, email,
    };
    if (cid) {
      formData['invited_by'] = cid;
    }
    fetch('/api/recover_or_create_challenge.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(formData)
    })
      .then(response => response.json())
      .then(data => {
        if (data.token) {
          console.log("recover_or_create_challenge.php token:", data.token, data.cid);
          localStorage.setItem(KEY_OWN_CID, data.cid);
          localStorage.setItem(KEY_TOKEN, data.token);
          navigate("/challenge/" + data.cid);
        } else if (data.status) {
          console.log("recover_or_create_challenge.php status:", data.status);
          if (data.status === "exists") {
            navigate("/challenge/recover")
          }
        } else {
          console.log("recover_or_create_challenge.php error:", data.error);
        }
      })
      .catch(error => console.error('Error:', error));
  }



  return (
    <div className="generic-page" >
      <div className="narrow-content" style={{
        //fontFamily: "'Times New Roman', Times, serif"
      }}>
        {/*<h1>{t('buy-european-challenge.title')}</h1>*/}
        <Header>{t('challenge.join-buy-european.header')}</Header>
        <Subheader>
          {t('challenge.join-buy-european.subheader')}
        </Subheader>
        <form onSubmit={handleJoinSubmit}>
          <FormContainer>
            <Label>{t('name-or-nickname.label')}</Label>
            <TextEditor
              requestFocus 
              value={name} onChange={(v) => setNameAndMaybeClearError(v)} />
            <Spacer $height="15px" />
            <Label>{t('email-optional.label')}</Label>
            <TextEditor
              value={email} onChange={(v) => setEmail(v)} />
            <SmallText>
              {t('challenge.email-privacy.smalltext')}
            </SmallText>

            {error && <StatusText>{error}</StatusText>}
            <PlainButtonBar style={{marginTop: '1.8rem'}}>
              <Spacer style={{flexGrow: 1}} />
              <SecondaryButton type='button' onClick={handleBack}>{t('back.button')}</SecondaryButton>
              <SecondaryButton type='button' onClick={() => setLearnMoreOpen(true)}>{t('learn-more.button')}</SecondaryButton>
              <PrimaryButton type='submit'>{t('challenge.accept-challenge.button')}</PrimaryButton>
              <Spacer style={{flexGrow: 1}} />
            </PlainButtonBar>
            <Spacer $height="1rem" />
            <Link style={{width: '100%', textAlign: 'center'}} to="/challenge/email-prompt">{t('challenge.already-joined.link')}</Link>
          </FormContainer>
        </form>
        {isLearnMoreOpen && <ChallengeLearnMore onClose={() => setLearnMoreOpen(false)} />}
      </div>
    </div>
  )
}

const Header = styled.h1`

`

const Subheader = styled.div`
  font-weight: 400;
  font-size: 1.15rem;
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-bottom: 1.5rem;
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  align-items: left;
`
